import { useEffect, useRef } from 'react'

import { useLocation } from 'react-router-dom'

import { track } from '@/shared/analytics/analyticsService'

export interface OnboardingStepMeta {
	stepKey: string
	stepLabel: string
	totalSteps: number
}

export const useOnboardingStepTracking = (
	currentStep: number,
	meta: OnboardingStepMeta
) => {
	const location = useLocation()
	const lastStep = useRef<number>(currentStep)
	const hasTrackedInitial = useRef(false)

	const getStepUrl = () => {
		try {
			return window.location.href
		} catch {
			return `${location.pathname}?step=${currentStep}`
		}
	}

	useEffect(() => {
		const shouldTrack =
			!hasTrackedInitial.current || lastStep.current !== currentStep

		if (!shouldTrack) {
			return
		}

		const previousStep = hasTrackedInitial.current ? lastStep.current : null
		lastStep.current = currentStep
		hasTrackedInitial.current = true

		const stepUrl = getStepUrl()

		track('onboarding_step_viewed', {
			step: currentStep,
			step_key: meta.stepKey,
			step_label: meta.stepLabel,
			total_steps: meta.totalSteps,
			path: location.pathname,
			current_url: stepUrl,
		})

		// Track transitions to understand drop-off points (skip for initial view)
		if (previousStep !== null) {
			track('onboarding_step_transitioned', {
				from_step: previousStep,
				to_step: currentStep,
				path: location.pathname,
				current_url: stepUrl,
			})
		}
	}, [currentStep, location.pathname, meta])
}
